import {observer} from 'mobx-react';
import {ScheduleReportCreateModel} from '../model/ScheduleReportCreateModel.mdl';
import {Breadcrumbs, Button, Form, PageContainer, SliderPanel, Surface} from '@vidazoo/ui-kit';
import DetailsForm from '../../common/components/details-form/DetailsForm';
import theme from '../../common/theme.module.scss';
import * as React from 'react';
import UrlsService from '../../../../../common/router/services/urlsService.mdl';
import {useLocation, useNavigate} from 'react-router-dom';
import {useEffect} from 'react';
import {cloneDeep} from 'lodash';
import {IScheduleReport} from '../../../interfaces/IScheduleReport';
import ReportForm from '../../common/components/report-form/ReportForm';
import {useModuleFactory} from "@injex/react-plugin";

export default observer(function ScheduleReportCreate() {
    const model = useModuleFactory<ScheduleReportCreateModel>('scheduleReportCreateModel');
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        model.reset();
        const duplicate = (location.state as {duplicate?: IScheduleReport})?.duplicate;
        if (duplicate) {
            const item = cloneDeep(duplicate);
            delete item._id;
            item.name = '';
            model.item.data = item;
        }
    }, [model, location.key]);

    const breadcrumbs = [{
        label: "Schedule Reports",
        iconName: "icon-calendar",
        link: {to: UrlsService.scheduleReports()}
    }, {
        label: "Create Schedule Report",
        primary: true
    }];

    const onCancelClick = () => {
        navigate(UrlsService.scheduleReports());
    };

    return (
        <PageContainer className={theme.page} pageTitle="Create Schedule Report" inner top={1.2}>
            <Breadcrumbs className={theme.breadcrumbs} breadcrumbs={breadcrumbs}/>
            <Form className={theme.form} onSubmit={model.submit}>
                <div className={theme.midContent}>
                    <Surface className={theme.surface} level={1}>
                        <DetailsForm model={model}/>
                    </Surface>
                    <Surface className={theme.surface} level={1}>
                        <ReportForm model={model}/>
                    </Surface>
                </div>
                <SliderPanel>
                    <div className={theme.actions}>
                        <Button type="button" medium gray uppercase onClick={onCancelClick}>Cancel</Button>
                        <Button type="submit" medium blue uppercase>Create</Button>
                    </div>
                </SliderPanel>
            </Form>
        </PageContainer>
    );
});
